import React, { useState } from 'react';
import { X } from 'lucide-react';
import '../styles/AddItemsModal.css';
import '../styles/DrawerForm.css';

interface ConstructionStatusBulkUpdateModalProps {
  selectedCount: number;
  selectedUnitNos: string[];
  onUpdate: (data: {
    constructionStatus: string;
    dateStatus?: string;
  }) => void;
  onCancel: () => void;
}

const ConstructionStatusBulkUpdateModal: React.FC<ConstructionStatusBulkUpdateModalProps> = ({
  selectedCount,
  selectedUnitNos,
  onUpdate,
  onCancel
}) => {
  const [constructionStatus, setConstructionStatus] = useState('');
  const [dateStatus, setDateStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!constructionStatus) {
      alert('Please select a construction status');
      return;
    }

    setLoading(true);
    try {
      await onUpdate({
        constructionStatus,
        dateStatus: dateStatus || undefined
      });
    } finally {
      setLoading(false);
    }
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  return (
    <div className="modal-overlay" onClick={loading ? undefined : onCancel}>
      <div className="modal-content" style={{ maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Bulk Change Status</h3>
          <button className="modal-close" onClick={onCancel} disabled={loading}>
            <X size={20} />
          </button>
        </div>

        <div className="modal-body">
          <div style={{
            padding: '12px',
            backgroundColor: '#F5E6ED',
            border: '1px solid #E5C9D9',
            borderRadius: '6px',
            marginBottom: '20px'
          }}>
            <p style={{ fontSize: '14px', color: '#48182F', fontWeight: 'bold', marginBottom: '8px' }}>
              Change construction status to the following suites:
            </p>
            <p style={{ fontSize: '14px', color: '#48182F', margin: 0 }}>
              {selectedUnitNos.join(' , ')}
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {/* Construction Status */}
              <div className="form-group">
                <label htmlFor="constructionStatus" className="form-label">
                  Construction Status:
                </label>
                <select
                  id="constructionStatus"
                  className="form-input"
                  value={constructionStatus}
                  onChange={(e) => setConstructionStatus(e.target.value)}
                  disabled={loading}
                  required
                >
                  <option value="">Select Construction Status</option>
                  <option value="Under Construction">Under Construction</option>
                  <option value="Released on Condition">Released on Condition</option>
                  <option value="Released">Released</option>
                </select>
              </div>

              {/* Date Status */}
              <div className="form-group">
                <label htmlFor="dateStatus" className="form-label">
                  Date Status:
                </label>
                <input
                  type="date"
                  id="dateStatus"
                  className="form-input"
                  value={dateStatus}
                  onChange={(e) => setDateStatus(e.target.value)}
                  disabled={loading}
                />
              </div>
            </div>

            <div className="modal-footer" style={{ marginTop: '24px' }}>
              <button
                type="button"
                className="btn btn-secondary btn-md"
                onClick={onCancel}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className={`btn btn-primary btn-md ${loading ? 'btn-loading' : ''}`}
                disabled={loading}
              >
                {loading ? '' : 'Update'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ConstructionStatusBulkUpdateModal;
